import React from 'react';
import { Space, Typography } from 'antd';
import { AppstoreOutlined, CheckSquareOutlined, DatabaseOutlined } from '@ant-design/icons';
import { Archive } from 'lucide-react';
import { StatCard, BigStatValue } from '@/features/trainings/components/ModelDetailsStatCard';

const STAT_CARDS_CONFIG = [
    { key: 'totalApps', label: 'Total Projects', icon: <AppstoreOutlined /> },
    { key: 'totalUseCases', label: 'Total Tasks', icon: <Archive size={14} /> },
    { key: 'totalDatasets', label: 'Total Datasets', icon: <DatabaseOutlined /> },
    { key: 'totalBenchmarks', label: 'Total Benchmarks', icon: <CheckSquareOutlined /> },
];

const STAT_LABEL_STYLE = { color: '#6B7280', fontSize: 13 };

const TopStatCards = ({ metrics, loading }) => {
    return (
        <div
            className="fs-unmask"
            style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
                gap: 16,
                marginBottom: 24,
            }}
        >
            {STAT_CARDS_CONFIG.map(({ key, label, icon }) => (
                <StatCard key={key} label={null} minHeight={96}>
                    <Space size={8} style={STAT_LABEL_STYLE}>
                        {icon}
                        <Typography.Text style={STAT_LABEL_STYLE}>{label}</Typography.Text>
                    </Space>
                    <div style={{ marginTop: 6 }}>
                        <BigStatValue>{loading ? '-' : (metrics?.[key] ?? 0)}</BigStatValue>
                    </div>
                </StatCard>
            ))}
        </div>
    );
};

export default TopStatCards;
